import { call, put, takeLatest } from 'redux-saga/effects';
import actions, { Types } from '~/store/ducks/payments';
import api from '~/services/api';

function* loadPayments({ partner, params }) {
  try {
    const { data } = yield call(
      api.get,
      `/v1/partners/${partner}/settlements`,
      {
        params
      }
    );
    yield put(actions.loadPaymentsSuccess(data || {}));
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

function* loadMorePayments({ partner, params }) {
  try {
    const { data } = yield call(
      api.get,
      `/v1/partners/${partner}/settlements`,
      {
        params
      }
    );
    yield put(actions.loadMorePaymentsSuccess(data));
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

function* exportPayments({ partner, params }) {
  try {
    const { data } = yield call(
      api.get,
      `/v1/partners/${partner}/movements/export`,
      {
        params: {
          start: 0,
          type: 'partner',
          reference_field: 'movement',
          end_date: `${params.end_date}T03:00:00.000Z`,
          start_date: `${params.start_date}T02:59:59.000Z`
        }
      }
    );

    yield put(actions.exportPaymentsSuccess());

    const blob = new Blob([data], { type: 'text/csv;charset=utf-8' });
    const link = document.createElement('a');

    link.href = window.URL.createObjectURL(blob);
    link.download = `payments-${new Date().getTime()}.csv`;
    link.click();
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

function* exportPayment({ partner, params }) {
  try {
    const { data } = yield call(
      api.get,
      `/v1/partners/${partner}/movements/export`,
      {
        params: {
          start: 0,
          type: 'partner',
          reference_field: 'movement',
          start_date: `${params.start_date}T00:00:00.000Z`,
          end_date: `${params.end_date}T23:59:59.000Z`
        }
      }
    );

    yield put(actions.exportPaymentSuccess());

    const blob = new Blob([data], { type: 'text/csv;charset=utf-8' });
    const link = document.createElement('a');

    link.href = window.URL.createObjectURL(blob);
    link.download = `charges-${new Date().getTime()}.csv`;
    link.click();
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

function* loadPayment({ partner, params }) {
  try {
    const { data: transactions } = yield call(
      api.get,
      `/v1/partners/${partner}/movements`,
      {
        params
      }
    );

    yield put(actions.loadPaymentTransactionsSuccess(transactions));

    const { data: consolidated } = yield call(
      api.get,
      `/v1/partners/${partner}/movements/consolidated`,
      {
        params
      }
    );

    yield put(actions.loadPaymentConsolidatedSuccess(consolidated));

    const { data } = yield call(
      api.get,
      `/v1/partners/${partner}/settlements`,
      {
        params: {
          start_date: params.start_date,
          end_date: params.end_date
        }
      }
    );

    const defaultData = {
      compensate_at: '',
      amount: 0,
      details: []
    };

    const { amount, details, compensate_at } = data.entries[0] || defaultData;
    const getAmount = type => details.filter(i => i.type === type).amount;
    const amount_recipient = getAmount('recipient') || amount;
    const amount_partner = getAmount('partner') || 0;
    const res = {
      compensate_at,
      amount,
      amount_recipient,
      amount_partner
    };

    yield put(actions.loadPaymentSuccess(res));
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

function* loadMorePaymentTransactions({ partner, params }) {
  try {
    const { data } = yield call(api.get, `/v1/partners/${partner}/movements`, {
      params
    });
    yield put(actions.loadMorePaymentTransactionsSuccess(data));
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

const sagas = [
  takeLatest(Types.LOAD_PAYMENTS, loadPayments),
  takeLatest(Types.LOAD_MORE_PAYMENTS, loadMorePayments),
  takeLatest(Types.EXPORT_PAYMENTS, exportPayments),
  takeLatest(Types.EXPORT_PAYMENT, exportPayment),
  takeLatest(Types.LOAD_PAYMENT, loadPayment),
  takeLatest(Types.LOAD_MORE_PAYMENT_TRANSACTIONS, loadMorePaymentTransactions)
];

export default sagas;
